import { Button, TextField } from "@mui/material";

import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import axios from "axios";
import "../Settlement Tracker/settlementTracker.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Sidebar from "../Sidebar";
import { NavBar } from "../Navbar/NavBar";
function RevoleTracker() {
  const navigator = useNavigate();
  const [data, setData] = useState();
  const [page, setPage] = useState(1);
  const [limit, setLimt] = useState(5);
  const [perPage, setPerPage] = useState(5);
  const [totalCount, setTotalCount] = useState(0);
  const collectionElement = useRef();
  const penaltyElement = useRef();
  const [singleRevoke, setSingleRevoke] = useState();
  const [penaltyObject, setPenaltyObject] = useState();
  const [collectedObject, setCollectedObject] = useState();
  const [isFlag, setIsFlag] = useState(false);
  const [selectedCollection, setSelectedCollection] = useState();
  const [search, setSearch] = useState();
  const token = localStorage.getItem("token");
  // ============================================ Get All orders =============================

  const getOrders = () => {
    if (page === "") {
      return;
    }

    const query = [];
    if (search) {
      query.push(`&order_id=${search}`);
    }
    axios
      .get(
        `/workflow/api/banking/orders/settled?page=${page}&limit=${limit}${
          query?.length ? query?.join("&") : ""
        }`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      )
      .then((response) => {
        let newKeyValue = { isPenalty: false };
        let newObj = { isCollecte: false };
        const final = response?.data?.orders?.rows?.map((item) => ({
          ...item,
          ...newKeyValue,
          ...newObj,
        }));

        setData(final);
        setTotalCount(response?.data?.orders?.count);
      })
      .catch((error) => {
        console.log(error);
      });
  };
  useEffect(() => {
    getOrders();
  }, [page]);
  // Pagination

  // ================================================== Search Handler ===============================
  const searchHandler = (e) => {
    e.persist();
    setTimeout(() => {
      setSearch(e.target.value?.trim());
    }, 1500);
  };
  useEffect(() => {
    setPage("");
    setTimeout(() => {
      setPage(1);
    }, 100);
  }, [search]);
  const handlePrevPage = () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };
  const handleNextPage = () => {
    if (totalCount > page * limit) {
      setPage(page + 1);
    }
  };

  // ==================================== Radio Click handler ======================================
  const [selectedOrderId, setSelectedOrderId] = useState();
  const handleCollecttionRadioClick = (e, id, j) => {
    collectionElement.current = e.target.value;
    setSelectedCollection(e.target.value);
    // const temp = data?.filter((item)=>id===item?.id)
    console.log(e.target.value);
    // setPenaltyObject()
    const updatedArray = data?.map((obj) => {
      if (obj?.order_id === id) {
        let dd = {
          ...obj,
          e_collection_details: obj?.e_collection_details?.filter(
            (item, i) => i !== j
          ),
          isCollecte: true,
        };
        console.log(dd, "---------------------- fdd------");
        setCollectedObject(dd);
        setSingleRevoke({
          ...dd,
          revoke_amount: JSON.parse(collectionElement.current)?.amount_settled,
          bank: JSON.parse(collectionElement.current)?.collection_bank,
          collection_id: JSON.parse(collectionElement.current)?.collection_id,
        });

        return dd;
      }
      return obj;
    });
  };
  console.log(
    selectedCollection,
    "--------------------------- selected collection --------------------------"
  );
  const handlePenaltyRadioClick = (e, id, i) => {
    penaltyElement.current = e.target.value;
    // setCollectedObject()
    const updatedArray = data?.map((obj) => {
      if (obj?.order_id === id) {
        let pen = {
          ...obj,
          partial_payment_data: obj?.partial_payment_data?.filter(
            (el, j) => j !== i
          ),
          isPenalty: true,
        };

        console.log(
          pen,
          "------------------------- pen ----------------------------"
        );
        setSingleRevoke({
          ...singleRevoke,
          partial_payment_data: obj?.partial_payment_data?.filter(
            (el, j) => j !== i
          ),
        });
        setPenaltyObject(pen);
        return pen;
      }
      return obj;
    });

    // setData(updatedArray);
  };
  console.log(
    "----------------------------------",
    singleRevoke,
    "---------------------------------"
  );
  console.log(penaltyObject);
  // useEffect(() => {
  //   console.log(data);
  // }, [isFlag]);
  // ===================================== Revoke handler ==========================
  const revokeHandler = () => {
    if (penaltyObject) {
      axios
        ?.patch(`/workflow/api/banking/orders/revoke`, singleRevoke, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        })
        .then((response) => {
          console.log(response);
          getOrders();
          setCollectedObject();
          setPenaltyObject();
          setSelectedCollection();
          toast.success(response?.data?.message);
          // collectionElement = null;
          // penaltyElement = null;
          // setIsFlag(!isFlag);
          // setPage(1);
          window.location.reload();
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      toast.error("Please select penalty");
    }
  };

  useEffect(() => {
    console.log(isFlag);
  }, [isFlag]);
  console.log(collectionElement);
  console.log(penaltyElement);
  return (
    <div className="flex">
      <div className="mt-5 ml-8 builk-main ">
        <div className="p-3">
          <div className="flex justify-end ">
            <Button
              variant="contained"
              onClick={() => navigator("/settlement-tracker")}
            >
              Back
            </Button>
          </div>
          <input
            className="shadow-lg shadow-cyan-500/50 rounded-md w-100 h-10 mt-2 border border-gray-300 py-2 px-3 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-gray-400 focus:ring-offset-1 disabled:cursor-not-allowed disabled:opacity-50 dark:border-gray-700 dark:text-gray-50 dark:focus:ring-gray-400 dark:focus:ring-offset-gray-900"
            type="text"
            placeholder=" Search Order Id "
            style={{ border: "0.5px solid gray", borderRadius: "5px" }}
            onChange={(e) => searchHandler(e)}
          />
          <TableContainer component={Paper} className="mt-3">
            <Table aria-label="customized table">
              <TableHead>
                <TableRow>
                  <TableCell
                    align="center"
                    style={{
                      backgroundColor: "#343A40",
                      color: "#fff",
                      borderRadius: "7px",
                    }}
                    className="fw-bolder"
                  >
                    Order Id
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{
                      backgroundColor: "#343A40",
                      color: "#fff",
                      borderRadius: "7px",
                    }}
                    className="fw-bolder"
                  >
                    Paid amount
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{
                      backgroundColor: "#343A40",
                      color: "#fff",
                      borderRadius: "7px",
                    }}
                    className="fw-bolder"
                  >
                    Collections
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{
                      backgroundColor: "#343A40",
                      color: "#fff",
                      borderRadius: "7px",
                    }}
                    className="fw-bolder"
                  >
                    Partial Payment
                  </TableCell>
                  <TableCell
                    align="center"
                    style={{
                      backgroundColor: "#343A40",
                      color: "#fff",
                      borderRadius: "7px",
                    }}
                    className="fw-bolder"
                  >
                    Action
                  </TableCell>
                  {/* <TableCell align="center" style={{backgroundColor:'#343A40',color:"#fff"}}>Protein&nbsp;(g)</TableCell> */}
                </TableRow>
              </TableHead>
              {data ? (
                <TableBody>
                  {data?.map((item, index) => (
                    <TableRow>
                      <TableCell align="center" style={{ borderRadius: "7px" }}>
                        {item?.order_id}
                      </TableCell>
                      <TableCell align="center" style={{ borderRadius: "7px" }}>
                        {item?.paid_amount}
                      </TableCell>
                      <TableCell align="center" style={{ borderRadius: "7px" }}>
                        {item?.e_collection_details &&
                        item?.e_collection_details.length > 0 ? (
                          <Paper>
                            <TableContainer sx={{ maxHeight: 300 }}>
                              <Table
                                className="text-center"
                                stickyHeader
                                aria-label="sticky table"
                              >
                                <TableHead>
                                  <TableRow>
                                    <TableCell
                                      align="center"
                                      style={{ backgroundColor: "#ede9e8" }}
                                    >
                                      {/* <input type="radio" /> */}
                                    </TableCell>
                                    <TableCell
                                      style={{ backgroundColor: "#ede9e8" }}
                                      align="center"
                                      className="fw-bolder"
                                    >
                                      Collection Id
                                    </TableCell>
                                    <TableCell
                                      style={{ backgroundColor: "#ede9e8" }}
                                      align="center"
                                      className="fw-bolder"
                                    >
                                      Amount Collected
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {item?.e_collection_details?.map((el, j) => (
                                    <TableRow>
                                      <TableCell align="center">
                                        <input
                                          type="radio"
                                          name="collection"
                                          ref={collectionElement}
                                          value={JSON.stringify(el)}
                                          onClick={(e) =>
                                            handleCollecttionRadioClick(
                                              e,
                                              item?.order_id,
                                              j
                                            )
                                          }
                                        />
                                      </TableCell>
                                      <TableCell align="center">
                                        {el?.collection_id}
                                      </TableCell>
                                      <TableCell align="center">
                                        {el?.amount_settled}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Paper>
                        ) : (
                          ""
                        )}
                      </TableCell>
                      <TableCell align="center" style={{ borderRadius: "7px" }}>
                        {item?.partial_payment_data &&
                        item?.partial_payment_data?.length > 0 ? (
                          <Paper>
                            <TableContainer sx={{ maxHeight: 300 }}>
                              <Table
                                className="text-center"
                                stickyHeader
                                aria-label="sticky table"
                              >
                                <TableHead>
                                  <TableRow>
                                    <TableCell
                                      align="center"
                                      style={{ backgroundColor: "#ede9e8" }}
                                    >
                                      {/* <input type="radio" /> */}
                                    </TableCell>
                                    <TableCell
                                      style={{ backgroundColor: "#ede9e8" }}
                                      align="center"
                                      className="fw-bolder"
                                    >
                                      Id
                                    </TableCell>
                                    <TableCell
                                      style={{ backgroundColor: "#ede9e8" }}
                                      align="center"
                                      className="fw-bolder"
                                    >
                                      Amount Collected
                                    </TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {item?.partial_payment_data?.map((el, i) => (
                                    <TableRow key={el?.collection_id}>
                                      <TableCell align="center">
                                        <input
                                          type="radio"
                                          name="penalty"
                                          ref={penaltyElement}
                                          value={JSON.stringify(el)}
                                          onClick={(e) =>
                                            handlePenaltyRadioClick(
                                              e,
                                              item?.order_id,
                                              i
                                            )
                                          }
                                        />
                                      </TableCell>
                                      <TableCell align="center">
                                        {el?.id}
                                      </TableCell>
                                      <TableCell align="center">
                                        {el?.amount_collected}
                                      </TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Paper>
                        ) : (
                          ""
                        )}
                      </TableCell>
                      {console.log(penaltyObject, "penaltyObject")}
                      {console.log(collectedObject, "collectedObject")}
                      <TableCell align="center">
                        {singleRevoke?.order_id === item?.order_id &&
                        penaltyObject?.order_id ===
                          collectedObject?.order_id ? (
                          <Button
                            variant="contained"
                            className="fw-bolder"
                            onClick={revokeHandler}
                          >
                            <span>Edit Settlement </span>
                          </Button>
                        ) : (
                          ""
                        )}

                        {/* <button
                      className="fw-bolder"
                      onClick={revokeHandler}
                      disabled={penaltyObject ? false : true}
                    >
                      <span className="transition"></span>
                      <span className="gradient"></span>
                      <span className="label">Revoke</span>
                    </button> */}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              ) : (
                <TableBody>
                  <TableRow>
                    <TableCell align="center" />
                    <TableCell align="center" />
                    <TableCell align="center">
                      <div className="fw-bolder">No data found</div>
                    </TableCell>
                    <TableCell align="center" />
                    <TableCell align="center" />
                  </TableRow>
                </TableBody>
              )}
            </Table>
          </TableContainer>
          <div className="mt-3 d-flex justify-content-end gap-3">
            <Button
              variant="contained"
              style={{ backgroundColor: "#1F2937" }}
              onClick={() => handlePrevPage()}
            >
              Prev
            </Button>
            <Button
              variant="contained"
              style={{ backgroundColor: "#1F2937" }}
              onClick={() => handleNextPage()}
            >
              Next
            </Button>
          </div>
        </div>
        <ToastContainer />
      </div>
    </div>
  );
}

export default RevoleTracker;
